/**
 * per_pageずつ記事をajaxで読み込む
 */
/** プリフェッチがまだの場合にプリフェッチする */
import prefetchData from '../../../../../../src/assets/scripts/prefetch-rest-api.js';
/** アンカーへのスムーススクロール位置を合わせるために呼び出す */
import { fnc_scrollToHashOnLoad } from '../../../../../../src/assets/scripts/gsap-smoothScroll';

/** @type {number} 初期のページ番号 */
let page = 1;

/** @type {number} 1ページあたりの投稿数 */
const per_page = 10;

/** @type {string} カスタム投稿タイプ */
const post_type = 'news';

/** @type {HTMLElement} 投稿リストの要素 */
const postList = document.getElementById('js-news-postlist');

/**
 * loadPosts関数を呼び出すリスナーを定義します。
 */
function loadMorePosts() {
  loadPostsAfterDelay(0, false);
}

/**
 * clickイベントを無効にするリスナーを定義します。
 *
 * @param {Event} event - イベントオブジェクト
 */
function preventClick(event) {
  event.preventDefault();
}

/**
 * 投稿を読み込みます。初期の投稿を読み込む場合はプレースホルダーを置き換え、
 * 「もっと見る」ボタンがクリックされたときは新たに投稿を読み込みます。
 *
 * @param {boolean} [replacePlaceholder=false] - プレースホルダーを置き換えるかどうか。
 */
/* async function loadPosts(replacePlaceholder = false) {
  try {
    let url = `/wp-json/wp/v2/${post_type}?page=${page}&per_page=${per_page}`;

    //postListの兄弟要素の子要素の.js-load-moreを取得
    const loadMoreButton =
      postList.nextElementSibling.querySelector('.js-load-more');

    loadMoreButton.removeEventListener('click', loadMorePosts); // リスナーを削除
    loadMoreButton.removeEventListener('click', preventClick); // リスナーを削除
    loadMoreButton.addEventListener('click', loadMorePosts); // リスナーを再設定

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const posts = await response.json();
    if (response.headers.get('X-WP-TotalPages') === String(page)) {
      loadMoreButton.classList.add('is-no-load'); // クラスを追加
      loadMoreButton.removeEventListener('click', loadMorePosts); // リスナーを削除
      loadMoreButton.addEventListener('click', preventClick); // clickイベントを無効にするリスナーを設定
    } else {
      loadMoreButton.classList.remove('is-no-load'); // クラスを削除
      //cssで透明にしているボタンを表示させる
      loadMoreButton.style.opacity = '1';
    }

    // 既存のul要素を取得
    let postListUl = postList.querySelector('ul');
    // 既存のul要素がない場合のみ新しいul要素を作成
    if (!postListUl) {
      postListUl = document.createElement('ul');
      postListUl.className = '';
      postList.appendChild(postListUl);
    }

    // 記事のデータを元にプレースホルダーを差し替え
    // 新しい投稿をDOMに追加する処理が完了するまで待つ
    const newPosts = await Promise.all(
      posts.map(async (post, index) => {
        // 新しい投稿をDOMに追加する処理
        let newPost;

        //replacePlaceholderがfalseのとき
        if (!replacePlaceholder) {
          newPost = createNewPostElement(post);
          postListUl.appendChild(newPost);
        }

        return newPost;
      })
    );

    if (posts.length > 0) {
      page++; // 投稿がある場合のみページ番号をインクリメント
    }

    if (window.wpGlobalLenis) {
      //Lenisのスクロール可能領域を更新
      window.wpGlobalLenis.resize();
    }

    return newPosts;
  } catch (error) {
    console.error('読み込み中にエラーが発生しました:', error);
  }
}
 */
function loadPosts(replacePlaceholder = false) {
  let url = `/wp-json/wp/v2/${post_type}?page=${page}&per_page=${per_page}`;

  const loadMoreButton = postList.nextElementSibling.querySelector('.js-load-more');

  loadMoreButton.removeEventListener('click', loadMorePosts);
  loadMoreButton.removeEventListener('click', preventClick);
  loadMoreButton.addEventListener('click', loadMorePosts);

  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json().then((posts) => {
        if (response.headers.get('X-WP-TotalPages') === String(page)) {
          loadMoreButton.classList.add('is-no-load');
          loadMoreButton.removeEventListener('click', loadMorePosts);
          loadMoreButton.addEventListener('click', preventClick);
        } else {
          loadMoreButton.classList.remove('is-no-load');
          loadMoreButton.style.opacity = '1';
        }

        let postListUl = postList.querySelector('ul');
        if (!postListUl) {
          postListUl = document.createElement('ul');
          postListUl.className = '';
          postList.appendChild(postListUl);
        }

        const newPosts = posts.map((post, index) => {
          let newPost;
          if (!replacePlaceholder) {
            newPost = createNewPostElement(post);
            postListUl.appendChild(newPost);
          }
          return newPost;
        });

        if (posts.length > 0) {
          page++;
        }

        if (window.wpGlobalLenis) {
          window.wpGlobalLenis.resize();
        }

        return newPosts;
      });
    })
    .catch((error) => {
      console.error('読み込み中にエラーが発生しました:', error);
    });
}
/**
 * 投稿データからHTML文字列を生成します。
 *
 * @param {Object} post - 投稿データオブジェクト。
 * @returns {string} 投稿データから生成されたHTML文字列。
 */
function createPostHtml(post) {
  return `
  <a href="${post.link}">
  <p class="wp-block-cb-news-posts__post-date">${new Date(post.date)
      .toLocaleDateString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      .replace(/\//g, '.')}</p>
  <h3 class="wp-block-cb-news-posts__post-title">${post.title.rendered}</h3>
  <div class="wp-block-cb-mark-arrorw-forward is-style-default"><span class="material-symbols-outlined" aria-hidden="true"></span></div>
</a>
  `;
}

/**
 * 投稿データから新しい投稿要素を作成します。
 *
 * @param {Object} post - 投稿データ。
 * @returns {HTMLElement} 新しい投稿要素。
 */
function createNewPostElement(post) {
  // li要素を作成
  const postElement = document.createElement('li');
  postElement.innerHTML = createPostHtml(post);
  return postElement;
}

/**
 * 指定されたセレクタに対応するプレースホルダーにデータをセットします。
 *
 * @param {string} placeholderSelector - プレースホルダー要素のセレクタ。
 * @param {Object[]} data - 投稿データオブジェクトの配列。
 */
function setPlaceholderData(placeholderSelector, data) {
  const placeholder = document.querySelector(placeholderSelector);
  if (placeholder) {
    data.forEach((post) => {
      const element = document.createElement('li');
      element.innerHTML = createPostHtml(post);
      // プレースホルダーに新しい要素を追加
      placeholder.appendChild(element);
    });
  }
}

/* async function placeholderContainer(prefetchedDataKey, placeholderSelector) {
  // セッションストレージからプリフェッチしたデータを取得
  let prefetchedData = JSON.parse(
    sessionStorage.getItem(prefetchedDataKey)
  );

  if (prefetchedData) {
    //console.log(`${prefetchedDataKey}が存在します`);
    setPlaceholderData(placeholderSelector, prefetchedData);
  } else {
    //console.log(`${prefetchedDataKey}が存在しません。データをプリフェッチします。`);
    await prefetchData();
    // プリフェッチ後に再度データを取得
    prefetchedData = JSON.parse(
      sessionStorage.getItem(prefetchedDataKey)
    );
    if (prefetchedData) {
      setPlaceholderData(placeholderSelector, prefetchedData);
    }
  }
  // アンカーへのスムーススクロール位置を合わせる
  fnc_scrollToHashOnLoad(80);
} */
function placeholderContainer(prefetchedDataKey, placeholderSelector) {
  // セッションストレージからプリフェッチしたデータを取得
  let prefetchedData = JSON.parse(
    sessionStorage.getItem(prefetchedDataKey)
  );

  if (prefetchedData) {
    //console.log(`${prefetchedDataKey}が存在します`);
    setPlaceholderData(placeholderSelector, prefetchedData);
  } else {
    //console.log(`${prefetchedDataKey}が存在しません。データをプリフェッチします。`);
    prefetchData().then(() => {
      // プリフェッチ後に再度データを取得
      prefetchedData = JSON.parse(
        sessionStorage.getItem(prefetchedDataKey)
      );
      if (prefetchedData) {
        setPlaceholderData(placeholderSelector, prefetchedData);
      }
    });
  }
  // アンカーへのスムーススクロール位置を合わせる
  fnc_scrollToHashOnLoad(80);
}
/**
 * 指定した時間後に投稿を読み込みます。
 *
 * @param {number} delay - 遅延時間（ミリ秒）。
 * @param {boolean} replacePlaceholder - プレースホルダーを置き換えるかどうか。
 */
function loadPostsAfterDelay(delay, replacePlaceholder = false) {
  setTimeout(() => {
    loadPosts(replacePlaceholder);
  }, delay);
}

/** ========================
 * 実行
 * ========================== */
window.addEventListener(
  'DOMContentLoaded',
  () => {
    // プレースホルダーを作成
    placeholderContainer(
      'prefetchedData_news',
      '#js-news-placeholder'
    );
    // 初期の投稿を読み込む（プレースホルダーを置き換え）
    loadPostsAfterDelay(0, true);
  },
  false
);

window.addEventListener('load', function () {
  if (window.wpGlobalLenis) {
    // Lenisのスクロール可能領域を更新
    setTimeout(() => {
      window.wpGlobalLenis.resize();
      //console.log('Lenisのスクロール可能領域を更新しました');
    }, 2000);
  }
});
